/* Cellovi product gallery extras (Simo OK 2 Nov 2026): an image count, arrows and arrow keys,
   and a full-size view to zoom. Thumbnail clicks are still handled in cellovi.js; this file only moves between them. */
(function () {
  'use strict';
  if (window.__cvGallery) return; window.__cvGallery = true;
  var g = document.querySelector('[data-cv-gallery]'); if (!g) return;
  var main = g.querySelector('.pdp-main'); if (!main) return;
  var thumbs = function () { return Array.prototype.slice.call(g.querySelectorAll('[data-cv-thumb]')); };
  var count = g.querySelector('[data-cv-gcount]');
  function idx() { var t = thumbs(); for (var i = 0; i < t.length; i++) if (t[i].getAttribute('aria-pressed') === 'true') return i; return 0; }
  function sync() {
    var t = thumbs(), i = idx();
    if (count) count.textContent = (i + 1) + ' / ' + t.length;
    var cur = t[i]; if (cur && cur.scrollIntoView) { try { cur.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (x) {} }
  }
  function go(step) {
    var t = thumbs(); if (t.length < 2) return;
    var n = (idx() + step + t.length) % t.length; t[n].click();
  }
  g.addEventListener('click', function (e) { if (e.target.closest('[data-cv-thumb]')) setTimeout(sync, 0); });
  var prev = g.querySelector('[data-cv-gprev]'), next = g.querySelector('[data-cv-gnext]');
  if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
  if (next) next.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
  g.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { go(1); e.preventDefault(); }
    else if (e.key === 'ArrowLeft') { go(-1); e.preventDefault(); }
  });

  /* Swiping on phones is handled in snippets/cv-pdp-mobile.liquid; this file listens for its thumbnail clicks. */

  /* Full-size view: tap the image to open it large; pinch to zoom on phones */
  var box = null, boxImg = null, lastFocus = null;
  function big(src) { return src.replace(/([?&])width=\d+/, '$1width=2048'); }
  function close() { if (!box) return; box.hidden = true; document.body.classList.remove('cv-locked'); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  function open() {
    if (main.classList.contains('is-facts')) return;
    var img = main.querySelector('img'); if (!img || !img.src) return;
    if (!box) {
      box = document.createElement('div'); box.className = 'cv-zoom'; box.hidden = true;
      box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Image, full size');
      box.innerHTML = '<button type="button" class="cv-zoom-x" aria-label="Close full-size image">×</button><img alt="">';
      document.body.appendChild(box); boxImg = box.querySelector('img');
      box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('.cv-zoom-x')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box && !box.hidden) close(); });
    }
    lastFocus = document.activeElement;
    boxImg.src = big(img.currentSrc || img.src); boxImg.alt = img.alt || '';
    box.hidden = false; document.body.classList.add('cv-locked');
    box.querySelector('.cv-zoom-x').focus();
  }
  main.addEventListener('click', function (e) { if (e.target.closest('[data-cv-gprev],[data-cv-gnext],.pdp-facts')) return; open(); });
  sync();
})();
